import { render, staticRenderFns } from "./ClassesRemoveModal.vue?vue&type=template&id=61ebcb09&scoped=true&"
import script from "./ClassesRemoveModal.vue?vue&type=script&lang=js&"
export * from "./ClassesRemoveModal.vue?vue&type=script&lang=js&"
import style0 from "./ClassesRemoveModal.vue?vue&type=style&index=0&id=61ebcb09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ebcb09",
  null
  
)

export default component.exports